import FormSchemaParser from '@/components/Common/FormSchemaParser';
import FetchingFieldsLoader from '../FormPartials/FetchingFieldsLoader';
import OpenDentalForm from '../FormPartials/OpenDentalForm';
import CurveDentalForm from '../FormPartials/CurveDentalForm';
import GoogleCalendarForm from '../FormPartials/GoogleCalendarForm';
import ClioCalendarForm from '../FormPartials/ClioCalendarForm';
import OscarProForm from '../FormPartials/OscarProForm';
import AvarosForm from '../FormPartials/AvarosForm';
import OscarEmrForm from '../FormPartials/OscarEmrForm';
import CalComForm from '../FormPartials/CalComForm';
import JunoForm from '../FormPartials/JunoForm';
import TebraForm from '../FormPartials/TebraForm';
import AthenaHealthForm from '../FormPartials/AthenaHealthForm';
import NexHealthForm from '../FormPartials/NexHealthForm';
import JuvonnoForm from '../FormPartials/JuvonnoForm';
import AdvancedMdForm from '../FormPartials/AdvancedMdForm';
import ZandaForm from '../FormPartials/ZandaForm';
import CureMdForm from '../FormPartials/CureMdForm';
import CovetrusForm from '../FormPartials/CovetrusForm';

interface IntegrationPostConfigurationFieldsProps {
  selectedCode?: string;
  integrationId?: string;
  configFields?: any;
  namePrefix: string;
  control: any;
  disabled?: boolean;
  isLoading?: boolean;
  getValues?: any;
  setValue?: any;
  submitForm?: (val: any) => void;
  publicForm?: boolean;
  spacing?: string;
}

export default function IntegrationPostConfigurationFields({
  selectedCode,
  integrationId,
  configFields,
  namePrefix,
  control,
  disabled = false,
  isLoading = false,
  getValues,
  setValue,
  submitForm,
  publicForm = false,
  spacing = '16px'
}: IntegrationPostConfigurationFieldsProps) {
  if (isLoading) {
    return <FetchingFieldsLoader />;
  }

  if (selectedCode === 'open_dental') {
    return (
      <OpenDentalForm
        integrationId={integrationId!}
        disabled={disabled}
        configFields={configFields}
        namePrefix={namePrefix}
        control={control}
        spacing={spacing}
        submitForm={submitForm}
      />
    );
  }

  if (selectedCode === 'curve_dental') {
    return (
      <CurveDentalForm
        integrationId={integrationId!}
        disabled={disabled}
        configFields={configFields}
        namePrefix={namePrefix}
        control={control}
        spacing={spacing}
        submitForm={submitForm}
      />
    );
  }

  if (selectedCode === 'google_calendar') {
    return (
      <GoogleCalendarForm
        namePrefix={namePrefix}
        control={control}
        disabled={disabled}
        setValue={setValue}
        getValues={getValues}
        configFields={configFields}
        spacing={spacing}
        submitForm={submitForm}
      />
    );
  }

  if (selectedCode === 'clio_calendar') {
    return (
      <ClioCalendarForm
        namePrefix={namePrefix}
        control={control}
        disabled={disabled}
        setValue={setValue}
        getValues={getValues}
        configFields={configFields}
        spacing={spacing}
        submitForm={submitForm}
      />
    );
  }

  if (selectedCode === 'cal_com') {
    return (
      <CalComForm
        namePrefix={namePrefix}
        control={control}
        disabled={disabled}
        getValues={getValues}
        configFields={configFields}
        spacing={spacing}
        submitForm={submitForm}
      />
    );
  }

  if (selectedCode === 'oscar_pro') {
    return (
      <OscarProForm
        namePrefix={namePrefix}
        control={control}
        disabled={disabled}
        setValue={setValue}
        getValues={getValues}
        configFields={configFields}
        spacing={spacing}
        submitForm={submitForm}
      />
    );
  }

  if (selectedCode === 'avaros') {
    return (
      <AvarosForm
        namePrefix={namePrefix}
        control={control}
        disabled={disabled}
        setValue={setValue}
        getValues={getValues}
        configFields={configFields}
        spacing={spacing}
        submitForm={submitForm}
      />
    );
  }

  if (selectedCode === 'oscar_emr') {
    return (
      <OscarEmrForm
        namePrefix={namePrefix}
        control={control}
        disabled={disabled}
        getValues={getValues}
        configFields={configFields}
        spacing={spacing}
        submitForm={submitForm}
      />
    );
  }

  if (selectedCode === 'juno') {
    return (
      <JunoForm
        namePrefix={namePrefix}
        control={control}
        disabled={disabled}
        getValues={getValues}
        configFields={configFields}
        spacing={spacing}
        submitForm={submitForm}
      />
    );
  }

  if (selectedCode === 'tebra') {
    return (
      <TebraForm
        namePrefix={namePrefix}
        control={control}
        disabled={disabled}
        getValues={getValues}
        setValue={setValue}
        configFields={configFields}
        spacing={spacing}
        submitForm={submitForm}
      />
    );
  }

  if (selectedCode === 'athena_health') {
    return (
      <AthenaHealthForm
        namePrefix={namePrefix}
        control={control}
        disabled={disabled}
        getValues={getValues}
        configFields={configFields}
        spacing={spacing}
        submitForm={submitForm}
      />
    );
  }

  if (selectedCode === 'nex_health') {
    return (
      <NexHealthForm
        namePrefix={namePrefix}
        control={control}
        disabled={disabled}
        getValues={getValues}
        setValue={setValue}
        configFields={configFields}
        spacing={spacing}
        submitForm={submitForm}
      />
    );
  }

  if (selectedCode === 'juvonno') {
    return (
      <JuvonnoForm
        namePrefix={namePrefix}
        control={control}
        disabled={disabled}
        getValues={getValues}
        setValue={setValue}
        configFields={configFields}
        spacing={spacing}
        submitForm={submitForm}
      />
    );
  }

  if (selectedCode === 'advanced_md') {
    return (
      <AdvancedMdForm
        namePrefix={namePrefix}
        control={control}
        disabled={disabled}
        configFields={configFields}
        spacing={spacing || '16px'}
        submitForm={submitForm}
        publicForm={publicForm}
      />
    );
  }

  if (selectedCode === 'zanda') {
    return (
      <ZandaForm
        namePrefix={namePrefix}
        control={control}
        disabled={disabled}
        getValues={getValues}
        setValue={setValue}
        configFields={configFields}
        spacing={spacing}
        submitForm={submitForm}
      />
    );
  }

  if (selectedCode === 'cure_md') {
    return (
      <CureMdForm
        namePrefix={namePrefix}
        control={control}
        disabled={disabled}
        configFields={configFields}
        spacing={spacing}
        publicForm={publicForm}
        submitForm={submitForm}
      />
    );
  }

  if (selectedCode === 'covetrus') {
    return (
      <CovetrusForm
        namePrefix={namePrefix}
        control={control}
        disabled={disabled}
        getValues={getValues}
        setValue={setValue}
        configFields={configFields}
        spacing={spacing}
        submitForm={submitForm}
      />
    );
  }

  return (
    <FormSchemaParser
      publicForm={publicForm}
      gridSize={12}
      fields={configFields || []}
      disabled={disabled}
      control={control}
      namePrefix={namePrefix}
      spacing={spacing}
      submitForm={submitForm}
    />
  );
}
